
import React from 'react';
import {
  LayoutDashboard,
  Users,
  Briefcase,
  Cpu,
  Zap,
  Database,
  Activity,
  Settings,
} from 'lucide-react';
import { AdminView, User, Agent, Workspace, LogEntry } from './types';

export type NavigationItem = {
  id: AdminView;
  label: string;
  icon: React.ReactNode;
};

export const NAVIGATION_ITEMS: NavigationItem[] = [
  { id: AdminView.OVERVIEW, label: 'Overview', icon: <LayoutDashboard size={20} /> },
  { id: AdminView.USERS_ACCESS, label: 'Users & Access', icon: <Users size={20} /> },
  { id: AdminView.WORKSPACES, label: 'Workspaces', icon: <Briefcase size={20} /> },
  { id: AdminView.ORGANIZATIONS, label: 'Organizations', icon: <Briefcase size={20} /> },
  { id: AdminView.AGENTS_WORKFLOWS, label: 'Agents & Workflows', icon: <Cpu size={20} /> },
  { id: AdminView.MODELS_TOOLS, label: 'Models & Tools', icon: <Zap size={20} /> },
  { id: AdminView.DATA_INTEGRATIONS, label: 'Data & Integrations', icon: <Database size={20} /> },
  { id: AdminView.MONITORING_AUDIT, label: 'Monitoring & Audit', icon: <Activity size={20} /> },
  { id: AdminView.SETTINGS, label: 'Account Preferences', icon: <Settings size={20} /> },
];

export const MOCK_USERS: User[] = [
  { id: '1', name: 'Sunil Kumar', email: 'sunil@engazeiq.ai', role: 'Super Admin', status: 'Active', lastLogin: '2023-11-20 09:45', workspaces: ['Recruitment', 'Global'] },
  { id: '2', name: 'Arihant Jain', email: 'arihant@engazeiq.ai', role: 'Org Admin', status: 'Active', lastLogin: '2023-11-19 14:20', workspaces: ['Customer Support'] },
  { id: '3', name: 'Shantanu Sen', email: 'shantanu@engazeiq.ai', role: 'Builder', status: 'Active', lastLogin: '2023-11-20 11:10', workspaces: ['Smart City FM'] },
  { id: '4', name: 'John Doe', email: 'john@client.com', role: 'Viewer', status: 'Inactive', lastLogin: '2023-10-05 08:30', workspaces: ['Recruitment'] },
];

export const MOCK_AGENTS: Agent[] = [
  { id: '1', name: 'Recruitment Manager', type: 'Orchestrator', workspace: 'Recruitment', status: 'Published', lastUpdated: '2023-11-18', owner: 'Sunil Kumar' },
  { id: '2', name: 'Email Drafter', type: 'Tool', workspace: 'Global', status: 'Published', lastUpdated: '2023-11-15', owner: 'Arihant Jain' },
  { id: '3', name: 'FM Support Bot', type: 'Chat', workspace: 'Smart City FM', status: 'Draft', lastUpdated: '2023-11-19', owner: 'Shantanu Sen' },
];

export const MOCK_WORKSPACES: Workspace[] = [
  { id: '1', name: 'Recruitment', description: 'Talent acquisition and onboarding workflows.', owner: 'Sunil Kumar', agentCount: 12, userCount: 45, status: 'Active', members: [] },
  { id: '2', name: 'Customer Support', description: 'Handling tickets and live chat integrations.', owner: 'Arihant Jain', agentCount: 8, userCount: 120, status: 'Active', members: [] },
  { id: '3', name: 'Smart City FM', description: 'Facilities management and IoT alerts.', owner: 'Shantanu Sen', agentCount: 5, userCount: 15, status: 'Active', members: [] },
];

export const MOCK_LOGS: LogEntry[] = [
  { id: '101', timestamp: '2023-11-20 12:45:01', agent: 'Recruitment Manager', user: 'anonymous_user_4', status: 'success', latency: 450, tokens: 1200 },
  { id: '102', timestamp: '2023-11-20 12:44:55', agent: 'FM Support Bot', user: 'staff_12', status: 'error', latency: 1200, tokens: 0 },
  { id: '103', timestamp: '2023-11-20 12:44:30', agent: 'Email Drafter', user: 'arihant@engazeiq.ai', status: 'success', latency: 210, tokens: 450 },
];
